'use client'
import {usePathname, useSearchParams, useRouter} from 'next/navigation'
import {useOptimistic, useTransition} from 'react'

export const useOptimisticChecked = () => {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const checked = searchParams.get('pricing') !== 'monthly'
  const [optimisticChecked, setOptimisticChecked] = useOptimistic(checked)
  const [pending, startTransition] = useTransition()

  function handleCheckedChange(checked: boolean) {
    const params = new URLSearchParams(searchParams.toString())
    params.set('pricing', checked ? 'annual' : 'monthly')
    startTransition(() => {
      setOptimisticChecked(checked)
      router.push(`${pathname}?${params.toString()}`, {scroll: false})
    })
  }
  return {
    optimisticChecked,
    pending,
    handleCheckedChange,
  }
}
